/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Onh_HInputs */

const en_wc_onh_h = /** @type {(inputs: Wc_Onh_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use WordCraft online`)
};

/**
* | output |
* | --- |
* | "How to use WordCraft online" |
*
* @param {Wc_Onh_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_onh_h = /** @type {((inputs?: Wc_Onh_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Onh_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_onh_h(inputs)
});
export { wc_onh_h as "wc.onh.h" }